import React, { Component } from 'react'
import { getUser } from '~/redux/user/helpers'
import ListItem from '~/components/ListItem'
import RequireAuth from '~/components/RequireAuth'
import connect from '~/tools/connect'
import userStore from '~/redux/user/store'
import { getTransactionInfo } from '~/redux/uservideo/helpers.js'
import withInfiniteScrolling from '~/tools/withInfiniteScrolling'

class Library extends Component {	
	state = { 
		page: 1
	}
	
	fetchData() {
		return new Promise((resolve, reject) => {
			return getUser((user) => {
				if (user) {
					return getTransactionInfo(user.userId, true, this.state.page)
					.then((res) => {
						let content = []
						Object.keys(res.data.records).forEach(key => {
							content.push(res.data.records[key].contentResponse.gist)
						})
						this.setState({ page: this.state.page + 1 })
						resolve(content)
					})
				}
			})
		})
	}
	

	render() {
		return (
			<RequireAuth user={this.state.user}>
				<ListItem header="My Library" {...this.props} />
			</RequireAuth>
		)
	}
}

connect(
	Library,
	(state) => ({ user: state.user }),
	userStore
)

export default withInfiniteScrolling(Library);
